import Badges from 'modules/common/components/Badge';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'partial/components/Button';
import service from 'service';
import { Check } from '@phosphor-icons/react';
import { useQueryClient } from 'react-query';
import { useOrgTxnHistory } from '../hooks';

const MAP_STATUS = {
  // TRANSFORM STATUS LABEL
  PAID: 'APPROVED',
};

const MAP_TYPE = {
  CASH_IN: 'SMS REQUEST',
  SENDER_NAME_SUBSCRIPTION: 'MASK NAME',
};

function TransactionHistory() {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [approving, setApproving] = useState(false);
  const [isLoading, list, meta, refetch] = useOrgTxnHistory(filter, orgUuid);

  const format = [
    {
      label: 'date',
      key: 'created_at',
    },
    {
      label: 'type of transanction',
      key: ({ type }) => <span>{MAP_TYPE[type] || type}</span>,
    },
    {
      id: 'amount',
      key: ({ debit, credit }) => (
        <span>{debit !== '0.00' ? debit : credit}</span>
      ),
      label: 'amount',
    },
    {
      id: 'status',
      key: ({ status, uuid }) => (
        <div className="flex space-x-1 items-center flex-shrink-0">
          <div>
            <Badges status={MAP_STATUS[status] || status} />
          </div>
          {status === 'PENDING' ? (
            <Button
              success
              size="xs"
              disabled={approving}
              onClick={() => {
                if (
                  // eslint-disable-next-line no-restricted-globals, no-alert
                  !confirm('Are you sure you want to approve this sms request?')
                )
                  return;
                setApproving(true);
                service
                  .post(
                    `/core_wallet/v1/wallet_ledger/${orgUuid}/esms_approve`,
                    { uuid },
                  )
                  .then(() => {
                    toastSuccess('SMS credit request approved.');
                    setTimeout(() => {
                      refetch();
                      queryClient.invalidateQueries([
                        'show-organization-wallet',
                        orgUuid,
                      ]);
                    }, 1500);
                  })
                  .catch((err) => {
                    toastError(
                      err?.response?.data?.message || 'Approval failed.',
                    );
                  })
                  .finally(() => setApproving(false));
              }}
            >
              <Check />
            </Button>
          ) : null}
        </div>
      ),
      label: 'status',
      labelClassName: 'justify-end',
      contentClassName: 'flex justify-end',
    },
  ];
  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default TransactionHistory;
